import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from 'material-ui/styles/index';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';

const styles = ({ spacing: { unit } }) => ({
    root: {
        width: '100%',
    },
    button: {
        marginTop: unit * 2,
    },
});

function TakePhoto(props) {
    return (
        <div>
            <Typography>
                Scan your face
            </Typography>
            <Typography>
                Take picture of your face so we can match your identification document.
                Don't worry if you aren't looking your best, we won't share picture with anyone.
            </Typography>
            <Button
                className={props.classes.button}
                onClick={() => {
                    props.setApplicantTakenPhoto(true);
                }}
            >
                scan id
            </Button>
        </div>
    );
}

TakePhoto.propTypes = {
    setApplicantTakenPhoto: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TakePhoto);



// WEBPACK FOOTER //
// ./src/app/FormStepper/ApplicantIdVerification/components/TakePhoto.js